const getters = {
  numeroDocumento: (state) => state.numeroDocumento,
  idTipoDocumento: (state) => state.idTipoDocumento,
  idUnidadeAtual: (state) => state.idUnidadeAtual,
  dataEnvioInicio: (state) => state.dataEnvioInicio,
  dataEnvioFim: (state) => state.dataEnvioFim,
  listaTiposDocumento: (state) => state.listaTiposDocumento,
  listaUnidadesAutorizadas: (state) => state.listaUnidadesAutorizadas,
  listaDocumentos: (state) => state.listaDocumentos,
  buscandoDocumentosCaixaPostal: (state) => state.buscandoDocumentosCaixaPostal
}

export default getters
